export default "__VITE_ASSET__B4qCr_6b__"